export const getLogo = (state) => state?.containers?.appHome?.logo;

export const getDescription = (state) =>
  state?.containers?.appHome?.description;

export const getHeadline = (state) => state?.containers?.appHome?.headline;

export const getTicker = (state) => state?.containers?.ticker;

export const getLoading = (state) => state?.containers?.loading;
